export default __webpack_public_path__ + "static/media/info_banner.0b02d07c.jpg";